import axios from 'axios';
import { BASE_URI } from '@/api/CONST.js';

const PREFIX = `${BASE_URI}/support/v1/manage`;

/**
 * Create ticket response
 * @param {number} ticketId
 * @param {string} message
 * @returns Promise
 */
export const createTicketResponse = (ticketId, message) => axios.post(`${PREFIX}/tickets/${ticketId}/responses`, { message });

/**
 * Get tickets
 * @param {number} ticketId
 * @param {object} cancelToken
 * @returns Promise
 */
export const getTicket = (ticketId, cancelToken) => axios.get(`${PREFIX}/tickets/${ticketId}`, { cancelToken });

/**
 * Change ticket status
 * @param {number} ticketId
 * @param {string} status
 * @returns Promise
 */
export const changeTicketStatus = (ticketId, status) => axios.patch(`${PREFIX}/tickets/${ticketId}/status`, { status });

/**
 * Получение списка обращений
 *
 * @param {object} data
 * @param {string|number} data.courseId
 * @param {object} data.params
 * @returns {Promise<import('axios').AxiosResponse<object>>}
 */
export const getCourseTicketsList = ({ courseId, params }) => axios.get(`${BASE_URI}/support/v1/manage/courses/${courseId}/tickets`, { params });
